import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2, PenLine } from 'lucide-react';
import { haccpApi, erroreHaccp } from '../../haccpApi';

const ATTUATORE = /attuatore/i;
export const spaziAttuatore = (dati) => (dati?.documenti || []).flatMap((d) => d.spazi
  .filter((s) => !s.firmata && !s.ignorata && s.box && ATTUATORE.test(s.ruolo)).map((s) => ({ doc: d, spazio: s })));

// Attestati: il "Soggetto Attuatore" è il ristorante, lo firma il responsabile con la sua firma salvata in un tocco solo
export const FirmaTuttiAttuatore = ({ dati, onPrimaFirma, onCambiato }) => {
  const [busy, setBusy] = useState(false);
  const lista = spaziAttuatore(dati);
  if (lista.length < 2) return null;
  const mia = dati.mia_firma;

  const firmaTutti = async () => {
    if (!mia) { onPrimaFirma(lista[0]); return; }
    if (!window.confirm(`Metto la tua firma salvata (${mia.nome}) nello spazio "Soggetto Attuatore" di ${lista.length} attestati? Restano solo gli attestati firmati: quelli senza firma si cancellano.`)) return;
    setBusy(true);
    const falliti = [];
    for (const { doc, spazio } of lista) {
      try { await haccpApi.post(`/documenti/firme/${doc.id}/applica`, { spazio_id: spazio.id, chi: 'io', box: spazio.box, altri: [] }); }
      catch (e) { falliti.push(`${doc.nome}: ${erroreHaccp(e, 'non firmato')}`); }
    }
    setBusy(false);
    if (!falliti.length) toast.success(`Firmati ${lista.length} attestati`);
    else toast.error(`Firmati ${lista.length - falliti.length} su ${lista.length}. Non firmati: ${falliti.join('; ')}`, { duration: 10000 });
    onCambiato();
  };

  return (
    <div className="rounded-2xl border border-sky-200 bg-sky-50 p-3 space-y-2" data-testid="firme-attuatore-tutti">
      <p className="text-sm text-gray-800"><b>{lista.length} attestati</b> aspettano la tua firma come Soggetto Attuatore.</p>
      {!mia && <p className="text-[11px] text-gray-600">Firma il primo: la tua firma resta salvata e poi firmi gli altri in un tocco.</p>}
      <button onClick={firmaTutti} disabled={busy} data-testid="firme-attuatore-tutti-btn"
        className="w-full h-11 rounded-full bg-sky-700 hover:bg-sky-800 text-white text-sm font-semibold flex items-center justify-center gap-2 disabled:opacity-60 transition-colors">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <PenLine className="h-4 w-4" />}{mia ? `Firma tutti e ${lista.length}` : 'Firma il primo'}
      </button>
    </div>
  );
};
